"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.InvestorsTabContentEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../types");
var slices_1 = require("../../slices");
var document_factory_1 = require("./document-factory");
exports.InvestorsTabContentEntity = document_factory_1.documentFactory(types_1.DocumentType.INVESTORS_TAB_CONTENT, function (prismicDoc, normalizedDoc, logger) {
    var _a;
    return utils_1.compact(__assign(__assign({}, normalizedDoc), { body: slices_1.toSlices((_a = prismicDoc.data) === null || _a === void 0 ? void 0 : _a.body_slices, logger) }));
});
//# sourceMappingURL=investors_tab_content.js.map